import gql from "graphql-tag";

export const CREATE_BILLING_ACCOUNT = gql`
  mutation createBillingAccount($input: billingAccountInput) {
    createBillingAccount(input: $input)
  }
`;
